module.exports = __webpack_public_path__ + "fromGroomToMother-jp-b.b60530a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/fromGroomToMother-jp-b.jpg
// module id = OO8U
// module chunks = 0